/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Templateid2Inputs */

const en__field_templateid2 = /** @type {(inputs: _Field_Templateid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template ID`)
};

const de__field_templateid2 = /** @type {(inputs: _Field_Templateid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshop-Vorlagen-ID`)
};

/**
* | output |
* | --- |
* | "Template ID" |
*
* @param {_Field_Templateid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_templateid2 = /** @type {((inputs?: _Field_Templateid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Templateid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_templateid2(inputs)
	return de__field_templateid2(inputs)
});
export { _field_templateid2 as "_field_templateID" }